import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

export default function HighlightsMovies({
    Label,
    Options,
    Disabled,
    onOptionSelected,
    onInputCleared,
}) {
    // Function to extract text from an HTML-like string
    function extractText(htmlString) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        return doc.body.textContent.replace(/"/g, "");
    }

    // Custom function to handle input changes and detect empty input
    const handleInputChange = (event, value, reason) => {
        if (reason === "clear" || value === "") {
            // Trigger something when the input is cleared
            if (onInputCleared) {
                onInputCleared();
            }
        }
    };

    return (
        <Autocomplete
            disabled={Disabled}
            id="highlights-demo"
            sx={{
                width: ["100%", 300, 300, 300],
            }}
            options={Options}
            getOptionLabel={(option) => option.movie}
            renderInput={(params) => (
                <TextField {...params} label={Label} margin="normal" />
            )}
            onChange={(event, selectedOption) => {
                if (selectedOption === null) {
                    // Handle case where the clear button is clicked or input is cleared
                    if (onInputCleared) {
                        onInputCleared();
                    }
                }
                if (onOptionSelected) {
                    onOptionSelected(selectedOption);
                }
            }}
            onInputChange={handleInputChange}
            renderOption={(props, option, { inputValue }) => {
                const matches = match(option.movie, inputValue, {
                    insideWords: true,
                });
                const parts = parse(option.movie, matches);

                return (
                    <li {...props}>
                        <div>
                            {parts.map((part, index) => {
                                // Use map to transform each HTML-like string to plain text
                                const plainText = extractText(part.text);

                                return (
                                    <span
                                        key={index}
                                        style={{
                                            fontWeight: part.highlight
                                                ? 700
                                                : 400,
                                        }}
                                    >
                                        {plainText}
                                    </span>
                                );
                            })}
                        </div>
                    </li>
                );
            }}
        />
    );
}
